import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { userModify } from 'action-creators/user/modify';
import { showModal } from 'actions/response';
import Metrics from 'services/metrics';
import {
  getLoading,
  getUpdateError,
  getUpdateSuccess,
} from 'selectors/user/modify';
import { getLabels, getMessage, MODAL_ERROR, MODAL_SUCCESS } from './constants';
import { hasErrors } from './utils';
import Profile from './profile';
import { userModifyReset } from 'action-creators/user/modify/actionTypes';
import { useProfileForm } from 'containers/ProfileManager/hooks/useProfileForm';
import { editProfile } from 'containers/ProfileManager/redux/profile.actions';

function ProfileSection({
  user,
  loaded,
  error,
  success,
  onShowModal,
  onUpdateUser,
  resetModifyUser,
  profilesInfo,
  editProfile,
  translations
}) {
  const labels = getLabels(translations);
  const [form, setForm] = useState({
    username: user.username,
    firstname: user.firstname,
    lastname: user.lastname,
    user_hash: user.userhash,
  });

  const [formErrors, setFormErrors] = useState({});
  const [editEnable, setEditEnable] = useState(false);
  const [loading, setLoading] = useState(false);

  const {profileForm} = useProfileForm({ isEditing: true })
  const { user_image } = profilesInfo || {};


  useEffect(
    () => {
      if (loaded) setLoading(true);
      if (error) onFail();
      if (success) onSuccess();
    },
    [loaded, error, success],
  );

  useEffect(
    () => {
      if (user) {
        const { firstname, lastname } = user;
        setForm({ ...form, firstname, lastname });
      }
    },
    [user],
  );
  useEffect(() =>{
    return () => resetModifyUser();
  }, []);

  const displayModal = ({ data, type }) => {
    const message = getMessage({...data, translations: translations});
    const modal = {
      modalType: type,
      props: {
        message,
      },
    };
    onShowModal(modal);
  };

  const onSuccess = () => {
    handleToggle();
    setLoading(false);
    displayModal({ data: success, type: MODAL_SUCCESS });
  };

  const onFail = () => {
    setLoading(false);
    displayModal({ data: error, type: MODAL_ERROR });
  };

  const isValid = () => {
    const errors = hasErrors(form, translations);
    if (errors) {
      setFormErrors(errors);
      return false;
    }
    setFormErrors({});
    return true;
  };

  const handleToggle = () => {
    let label = 'Modificar';
    if (editEnable) {
      const { firstname, lastname } = user;
      setFormErrors({});
      setForm({ ...form, firstname, lastname });
      label = 'Cancelar';
    }
    setEditEnable(!editEnable);
    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',

      eventAction: 'Modificar Datos',
      eventLabel: label,
    });
  };

  const handleChange = ({ target }) => {
    setForm({ ...form, [target.name]: target.value });
  };

  const handleSave = e => {
    e.preventDefault();
    if (!isValid()) return;
    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',
      eventAction: 'Modificar Datos',
      eventLabel: 'Guardar',
    });
    onUpdateUser(form);
    editProfile({ ...profileForm, firstname :form?.firstname,  user_image, gamification_id: user?.gamification_id })
  };

  const className = {
    modify: editEnable ? '' : 'pull-right',
  };

  const isSpecialUser =
    user.username.indexOf('@NET.com.br') > -1 ||
    (user.data360 && user.data360.id_usuario);

  return !form.user_hash ? null : (
    <Profile
      label={labels}
      className={className}
      form={form}
      errors={formErrors}
      isEditMode={editEnable}
      isSpecialUser={isSpecialUser}
      loading={loading}
      onChange={handleChange}
      onSave={handleSave}
      onToggle={handleToggle}
    />
  );
}

ProfileSection.propTypes = {
  user: PropTypes.object,
  loaded: PropTypes.bool,
  error: PropTypes.object,
  success: PropTypes.bool,
  onShowModal: PropTypes.func.isRequired,
  onUpdateUser: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
  loaded: getLoading(state),
  error: getUpdateError(state),
  success: getUpdateSuccess(state),
  profilesInfo: state?.profilesManager?.profilesInfo,
  translations: state.translations
});

const mapDispatchToProps = dispatch => ({
  onShowModal(payload) {
    dispatch(showModal(payload));
  },
  onUpdateUser(payload) {
    dispatch(userModify(payload));
  },
  resetModifyUser() {
    dispatch(userModifyReset());
  },
  editProfile(payload){
    dispatch(editProfile(payload));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProfileSection);
